import { FC } from 'react';
import { format, parseISO } from 'date-fns';
import { ArticlePublishedTimeWrapper } from './ArticlePublishedTime.styles';

type Props = {
    dateTime?: string;
};

const ArticlePublishedTime: FC<Props> = ({ dateTime }) => {
    if (!dateTime) {
        return null;
    }

    return (
        <ArticlePublishedTimeWrapper dateTime={dateTime}>
            {format(parseISO(dateTime), 'dd MMMM yyyy')}
        </ArticlePublishedTimeWrapper>
    );
};

export default ArticlePublishedTime;
